import type { ChangeEvent, DragEvent } from 'react';
import { useEffect, useRef } from 'react';

import styles from './DisputeFileUpload.module.scss';
import type { DisputeFileUploadProps } from './DisputeFileUpload.types';
import { isDroppedFileValid, isFileValid } from './DisputeFileUpload.utils';

export const DisputeFileUpload = ({ label, file, inputId, onSetFile }: DisputeFileUploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!file && inputRef.current) {
      inputRef.current.value = '';
    }
  }, [file]);

  const handleDragOver = (event: DragEvent<HTMLElement>) => {
    event.preventDefault();
    event.currentTarget.classList.add('dragover');
  };

  const handleDragLeave = (event: DragEvent<HTMLElement>) => {
    event.currentTarget.classList.remove('dragover');
  };

  const handleDrop = (event: DragEvent<HTMLElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove('dragover');
    const droppedFile = event.dataTransfer.files?.[0];
    if (!droppedFile) return;
    if (!isDroppedFileValid(droppedFile)) return;
    onSetFile(droppedFile);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (isFileValid(event)) {
      onSetFile(event.target.files?.[0] ?? null);
    } else {
      if (inputRef.current) inputRef.current.value = '';
      onSetFile(null);
    }
  };

  return (
    <div className={styles.disputeCardFileForm}>
      <label>{label}</label>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => inputRef.current && inputRef.current.click()}
      >
        <input
          onChange={handleInputChange}
          ref={inputRef}
          type="file"
          id={inputId}
          placeholder="Файл не выбран"
          accept="image/bmp, image/jpg, image/png, image/gif, image/webp, image.jpeg, application/pdf"
          multiple={false}
          style={{ display: 'none' }}
        />
        <span>{file ? file.name : 'Выбрать файл'}</span>
      </div>
    </div>
  );
};
